import './pageNameAndSearch.css';
import Search from './Search';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function PageNameAndSearch() {
  const location = useLocation();
  const [pageName, setPageName] = useState('');

  useEffect(() => {
    const pathName = location.pathname;
    let currentPageName = '';

    switch (true) {
      case pathName === '/swapandtop':
      case pathName === '/swapandtop/':
      case pathName === '/swapandtop/posts':
        currentPageName = 'Home';
        break;
      case pathName === '/swapandtop/postnewitem':
        currentPageName = 'Post New Item';
        break;
      case pathName === '/swapandtop/myitemsandposts':
        currentPageName = 'My posts & watchlist';
        break;
      case pathName === '/swapandtop/myposts':
        currentPageName = 'My posts';
        break;
      case pathName === '/swapandtop/watchlist':
        currentPageName = 'My Watchlist';
        break;
      case pathName === '/swapandtop/settings':
        currentPageName = 'Settings';
        break;
      case pathName === '/swapandtop/postnewitempreview':
        currentPageName = 'Post preview';
        break;
      case /^\/swapandtop\/viewpost\/.+/.test(pathName):
      case /^\/swapandtop\/posts\/viewpost\/.+/.test(pathName):
        currentPageName = 'View Post';
        break;
      default:
        currentPageName = 'Page Not Found';
    }

    setPageName(currentPageName);
  }, [location.pathname]); // Dependency on location.pathname
  return (
    <>
      <div className='page-name-and-seach'>
        <label className='page-name-mobile'>{pageName}</label>
        <label className='page-name-web'>{pageName}</label>
        <Search />
      </div>
    </>
  );
}
